import { render, staticRenderFns } from "./HistoryActivations.vue?vue&type=template&id=849b43f0&scoped=true&"
import script from "./HistoryActivations.vue?vue&type=script&lang=js&"
export * from "./HistoryActivations.vue?vue&type=script&lang=js&"
import style0 from "./HistoryActivations.vue?vue&type=style&index=0&id=849b43f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849b43f0",
  null
  
)

export default component.exports